import * as React from 'react';

import { IconProvider } from '@/shared/icon-library';
import { RouterProvider, createBrowserRouter } from 'react-router';

import { PublicDocPage } from '@/features/public-doc/public-doc-page';
import { setPublicDocBackend } from '@/mock';
import { createPublicDocBackend } from '@/sync/public-doc';

import { ensureMockCache } from './mock-cache';

const LIVE = import.meta.env.VITE_DATA_MODE === 'live';

const MainApp = React.lazy(() => (LIVE ? import('./live-app') : import('./mock-app')));

const PUBLIC_DOC_PREFIX = '/p/';

let publicRouter: ReturnType<typeof createBrowserRouter> | null = null;

function PublicApp() {
  publicRouter ??= createBrowserRouter([{ path: `${PUBLIC_DOC_PREFIX}:token`, element: <PublicDocPage /> }]);
  if (LIVE) {
    setPublicDocBackend(createPublicDocBackend());
  } else {
    ensureMockCache();
  }
  return (
    <IconProvider>
      <RouterProvider router={publicRouter} />
    </IconProvider>
  );
}

export function App() {
  if (location.pathname.startsWith(PUBLIC_DOC_PREFIX)) {
    return <PublicApp />;
  }
  return (
    <React.Suspense fallback={<div className="h-screen bg-background" />}>
      <MainApp />
    </React.Suspense>
  );
}
